import { createFileRoute, Outlet, useMatch, useNavigate } from "@tanstack/react-router";
import { HelpCircle, Inbox, PenSquare } from "lucide-react";
import { usePublicConfig } from "@/api/queries/config";
import { Tabs } from "@/components/ui/Tabs";
import { useAuth } from "@/hooks/use-auth";
import { usePageMeta } from "@/hooks/use-page-meta";

export const Route = createFileRoute("/_public/help")({
	component: HelpLayout,
});

function HelpLayout() {
	const navigate = useNavigate();
	const { user } = useAuth();
	const isLoggedIn = !!user;
	const { data: config } = usePublicConfig();

	usePageMeta({
		title: config?.seo.titles.hilfe,
		description: config?.seo.descriptions.hilfe || undefined,
	});

	// Determine active tab from current route
	const faqMatch = useMatch({ from: "/_public/help/faq", shouldThrow: false });
	const ticketMatch = useMatch({ from: "/_public/help/ticket", shouldThrow: false });
	const ticketsMatch = useMatch({ from: "/_public/help/tickets/", shouldThrow: false });
	const ticketDetailMatch = useMatch({ from: "/_public/help/tickets/$id", shouldThrow: false });

	let activeTab = "faq";
	if (ticketMatch) activeTab = "ticket";
	if (ticketsMatch || ticketDetailMatch) activeTab = "tickets";
	if (faqMatch) activeTab = "faq";

	const tabs = [
		{ key: "faq", label: "FAQ", icon: <HelpCircle size={16} /> },
		{ key: "ticket", label: "Ticket erstellen", icon: <PenSquare size={16} /> },
		...(isLoggedIn ? [{ key: "tickets", label: "Meine Tickets", icon: <Inbox size={16} /> }] : []),
	];

	function handleTabChange(key: string) {
		switch (key) {
			case "faq":
				navigate({ to: "/help/faq" });
				break;
			case "ticket":
				navigate({ to: "/help/ticket" });
				break;
			case "tickets":
				navigate({ to: "/help/tickets" });
				break;
		}
	}

	return (
		<div className="max-w-3xl mx-auto space-y-6">
			<h1 className="text-2xl font-bold text-text">Hilfe & Support</h1>
			<Tabs tabs={tabs} activeKey={activeTab} onTabChange={handleTabChange} />
			<div>
				<Outlet />
			</div>
		</div>
	);
}
